import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=67e994dc&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=ts&"
export * from "./AddDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=67e994dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e994dc",
  null
  
)

export default component.exports